import React from 'react';

import { createRoot } from 'react-dom/client';

import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import { $placementsMap } from '@client/core/atoms/placements.js';
import { getInViewSettingsByBrand } from '@client/core/utils/getInViewSettingsByPlacementId.js';
import { RenderSponsoredContentOrChildren } from '@client/sponsoredContent/RenderSponsoredContentOrChildren.js';
import {
  AdServer,
  type PlacementId,
  Placements,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

import { debug } from '../.debug.js';
import GamAdUnit from './GamAdUnit.js';

export function renderGamAd(
  placementId: PlacementId,
  containerElement: Element | null
) {
  const placementElement = containerElement && createRoot(containerElement);
  const inViewSettings = getInViewSettingsByBrand(placementId);

  if (!placementElement) return;

  const placements = $placementsMap.get();

  if (!Object.keys(placements).length) {
    debug
      .withPlacementLabel(placementId)
      .message('Failed rendering due to empty placement map!', {
        placements,
        placementId,
        placementElement
      })
      .error();

    updateMetricByKey(placementId, PlacementStatus.NotInConfig);

    return;
  }

  const placement = placements[placementId];

  if (!placement) {
    debug
      .withPlacementLabel(placementId)
      .message('Placement not found in placement map!', {
        placements,
        placementId
      })
      .error();

    return;
  }

  if (!Placements.Gam.is(placement)) return;

  const Children = (
    <GamAdUnit placement={placement} inViewSettings={inViewSettings} />
  );

  placementElement.render(
    placement.overrideAdServer === AdServer.SponsoredContent ? (
      <RenderSponsoredContentOrChildren placement={placement}>
        {Children}
      </RenderSponsoredContentOrChildren>
    ) : (
      Children
    )
  );
}
